const getScrollTop = () => {
  if (document.body.scrollTop != 0) {
    return document.body.scrollTop;
  }

  if (document.documentElement.scrollTop != 0) {
    return document.documentElement.scrollTop;
  }

  return 0;
}

const setScrollTop = (top) => {

  document.body.scrollTop = top;
  document.documentElement.scrollTop = top;

}

const m = {
  getScrollTop,
  setScrollTop
}

module.exports = m;